import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './personallferrari_consultoria.module.scss';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5511940661541';
const WHATSAPP_MSG_CONSULTORIA =
    'Olá! Vi a página de consultoria online (Ferrari Silver/Gold) e quero saber qual plano combina comigo. Podemos conversar?';

const whatsappConsultoriaLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG_CONSULTORIA)}`;

const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/consultoria/consultoria1.png'), label: 'Consultoria 1' },
    { src: require('./src/consultoria/consultoria2.png'), label: 'Consultoria 2' },
    { src: require('./src/consultoria/consultoria3.png'), label: 'Consultoria 3' },
    { src: require('./src/consultoria/consultoria4.png'), label: 'Consultoria 4' },
    { src: require('./src/consultoria/consultoria5.png'), label: 'Consultoria 5' },
    { src: require('./src/consultoria/consultoria6.png'), label: 'Planos e valores' },
];

const Personallferrari_consultoria: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.personallferrari_consultoria}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/personallferrari"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao cartão digital"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Personal Ferrari</p>
                        <h1 className={styles.title}>Consultoria fitness online</h1>
                    </div>
                </div>

                <p className={styles.intro}>
                    Treinos e orientação com acompanhamento à distância, com a mesma seriedade de quem já formou milhares
                    de alunos. Veja como funciona e conheça os planos abaixo.
                </p>

                <div className={styles.grid}>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <img
                                src={item.src}
                                alt={`Consultoria online — ${item.label}`}
                                className={styles.cardImage}
                                loading={index < 2 ? 'eager' : 'lazy'}
                            />
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>

                <div className={styles.pricingSection} aria-labelledby="planos-heading">
                    <h2 id="planos-heading" className={styles.pricingTitle}>
                        Planos e valores
                    </h2>

                    <div className={styles.planCard}>
                        <p className={styles.planName}>Ferrari Silver</p>
                        <p className={styles.planPeriod}>Trimestral (3 meses)</p>
                        <p className={styles.planPrice}>
                            <strong>Parcelado:</strong> 3× de R$ 322,51
                            <br />
                            <strong>À vista:</strong> R$ 900,00
                        </p>
                    </div>

                    <div className={styles.planCard}>
                        <p className={styles.planName}>Ferrari Gold</p>
                        <p className={styles.planPeriod}>Semestral (6 meses)</p>
                        <p className={styles.planPrice}>
                            <strong>Parcelado:</strong> 6× de R$ 315,64
                            <br />
                            <strong>À vista:</strong> R$ 1.680,00
                        </p>
                    </div>

                    <div className={styles.dailyBox}>
                        <p className={styles.dailyTitle}>Quanto isso custa por dia?</p>
                        <p className={styles.dailyText}>
                            Dividindo o valor pelo número de dias do plano, o investimento diário na sua saúde fica
                            muito acessível, menos do que muitos gastam por dia com delivery ou café.
                        </p>
                        <ul className={styles.dailyList}>
                            <li>
                                <strong>Silver (à vista):</strong> R$ 900 ÷ 90 dias ≈ <strong>R$ 10,00/dia</strong>
                            </li>
                            <li>
                                <strong>Gold (à vista):</strong> R$ 1.680 ÷ 180 dias ≈ <strong>R$ 9,33/dia</strong>
                            </li>
                            <li>
                                <strong>No parcelado:</strong> o valor por dia fica na faixa de cerca de{' '}
                                <strong>R$ 10 a R$ 11</strong>, ainda assim um investimento pequeno para treino e
                                acompanhamento profissional.
                            </li>
                        </ul>
                        <p className={styles.dailyHighlight}>
                            Ou seja: por volta de um cafezinho por dia você coloca sua saúde e performance nas mãos de um
                            especialista.
                        </p>
                    </div>
                </div>

                <p className={styles.footerNote}>
                    Valores divulgados para referência, condições de pagamento e vigência podem ser confirmadas diretamente
                    no atendimento. Resultados dependem de adesão ao programa.
                </p>

                <div className={styles.ctaSection} aria-labelledby="cta-consultoria-heading">
                    <h2 id="cta-consultoria-heading" className={styles.ctaHeading}>
                        Escolha seu plano e comece hoje
                    </h2>
                    <p className={styles.ctaText}>
                        Tire dúvidas sobre Silver ou Gold, formas de pagamento e como começar sua consultoria online.
                        Resposta direto com o Personal Ferrari.
                    </p>
                    <a
                        href={whatsappConsultoriaLink}
                        className={styles.ctaWhatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#ffffff" />
                        <span>Falar no WhatsApp agora</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Personallferrari_consultoria;
